module.exports = __webpack_public_path__ + "static/media/chemistry.748606ad.jpg";